module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"svg":{"alia-label":{"search":"Refine Search Icon","sort":"Sort Icon"},"title":{"search":"Refine Search","sort":"Sort"},"desc":{"search":"Refine Search Icon","sort":"Sort Icon"}}}}')
  delete Component.options._Ctor
}
